import { connect } from 'react-redux';
import { deleteTier } from '../../redux/creator/actions';
const mapDispatchToProps = (dispatch, { deviation })=>({
        deleteTier: ()=>dispatch(deleteTier(deviation))
    });
export default connect(null, mapDispatchToProps);

//# sourceMappingURL=DeleteTier.container.js.map